import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#eceff1',
      200: '#b0bec5',
      main: '#607d8b',
      dark: '#546e7a',
      800: '#455a64',
    },
    secondary: {
      light: '#e0f2f1',
      200: '#80cbc4',
      main: '#009688',
      dark: '#00897b',
      800: '#00695c',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#121926',
      secondary: '#4b5565',
      disabled: '#cdd5df',
    },
    grey: {
      50: '#f8fafc',
      100: '#eef2f6',
      200: '#e3e8ef',
      300: '#cdd5df',
      500: '#697586',
      600: '#4b5565',
      700: '#364152',
      900: '#121926',
    },
    success: {
      light: '#b9f6ca',
      200: '#69f0ae',
      main: '#00e676',
      dark: '#00c853',
    },
    error: {
      light: '#ef9a9a',
      main: '#f44336',
      dark: '#c62828',
    },
    warning: {
      light: '#fff8e1',
      main: '#ffe57f',
      dark: '#ffc107',
    },
    info: {
      light: '#e3f2fd',
      main: '#2196f3',
      dark: '#2196f3',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    h1: { fontFamily: 'Roboto, sans-serif' },
    h2: { fontFamily: 'Roboto, sans-serif' },
    h3: { fontFamily: 'Roboto, sans-serif' },
    h4: { fontFamily: 'Roboto, sans-serif' },
    h5: { fontFamily: 'Roboto, sans-serif' },
    h6: { fontFamily: 'Roboto, sans-serif' },
    body1: { fontFamily: 'Roboto, sans-serif' },
    body2: { fontFamily: 'Roboto, sans-serif' },
    subtitle1: { fontFamily: 'Roboto, sans-serif' },
    subtitle2: { fontFamily: 'Roboto, sans-serif' },
    caption: { fontFamily: 'Roboto, sans-serif' },
    button: { fontFamily: 'Roboto, sans-serif' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontFamily: 'Roboto, sans-serif',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 48,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#eef2f6',
            fontWeight: 600,
            fontSize: '0.75rem',
            color: '#364152',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid var(--grey-200)',
          fontSize: '0.875rem',
          padding: '0 16px',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          backgroundColor: '#eef2f6',
        },
        columnHeader: {
          backgroundColor: '#eef2f6',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 16px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '13.5px 12px',
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        // Vertically center the resting label to match the 13.5px top padding.
        // Applies to both normal and small sizes (we normalised padding globally).
        root: {
          '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(12px, 13.5px) scale(1)',
          },
        },
      },
    },

    // The required asterisk (*) is rendered by FormLabel — colour it red.
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#f44336',
        },
      },
    },
  },
});

export default theme;
